import * as React from 'react';
import axios from 'axios';
import AuthContext from '../contexts/AuthContext';

const request = async (endpoint, data, handleError, token) => {
  try {
    const response = await axios({
      // url: env.SERVER_URI +endpoint,
      url: endpoint,
      method: 'POST',
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    //console.error(error.response.data.error);
    handleError(error);
    return null;
  }
};

const cafe24Request = async (endpoint, data, handleError, token) => {
  try {
    const response = await axios({
      url: endpoint,
      method: 'GET',
      params: data,
    });
    return response;
  } catch (error) {
    handleError(error);
    return null;
  }
};

const KGInicisPaymentRequest = async (endpoint, handleError) => {

  const {auth:token} = React.useContext(AuthContext);
  try {
    const response = await axios({
      url: endpoint,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export default { request, cafe24Request, KGInicisPaymentRequest };
